export default function (ctx) {
  const { route, } = ctx
  let redirectLoginPath = `/editor/no-mobile-access/`;

  switch (route.name) {
    default:
      if (ctx.isMobile) {
        // if session is missing then no access is allowed - we only allow logged in users
        // #### NO ACCESS ######
        // redirect(ctx, redirectLoginPath)
        ctx.redirect(redirectLoginPath)
      }

      // #### ACCESS GRANTED ######
      break
  }
}
